<div class="container u-mt60 padding-bottom">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
          <li>
            <a routerLink="/tasks/task-list">
              Tareas
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-12">
      <h1 class="u-mb10 txt txt--title">
        Notificaciones y tareas pendientes
      </h1>
      <a routerLink="/tasks/task-list" class="back back--small  u-mb20">
        <b>Actualización de antecedentes</b>
      </a>
    </div>
    <div class="col-md-12">
      <div class="u-bt u-bt--grey u-bb u-bb--grey">

        <div class="row">
          <div class="col-md-8 u-pt30 u-pb10">
            <h3 class="txt txt--section">
              Minera {{assetName}} <span class="txt txt--paragraph u-pl10">Nº: {{id}}</span>
            </h3>
            <p class="txt txt--paragraph txt--status txt--status--wait">
              <strong>
                Estado: Pendiente de aprobación
              </strong>
            </p>
          </div>
        </div>
      </div>

      <div class="u-bb u-bb--grey">
        <div class="row">
          <app-flow-states [id]="id" [centered]="false"></app-flow-states>
        </div>
      </div>

      <ng-container *ngIf="this.detailData">
        <div *ngFor="let item of detailData.equipments; let index = index;">
          <app-equipment-row [index]="index" [equipmentId]="item.equipmentId" [equipmentName]="item.equipmentName"
            [equipmentBrand]="item.equipmentBrand" [equipmentModel]="item.equipmentModel"
            [licenseTypes]="item.licenseTypes" [conductionZones]="item.conductionZones" [expiredAt]="item.expiredAt"
            [municipalLicenses]="item.municipalLicenses" [state]="item.equipmentStatus">
          </app-equipment-row>
        </div>
        <div class="table table--documents u-mb20">
          <div class="thead thead--border ">
            <div class="tr">
              <div class="th">Nombre documento</div>
              <div class="th">Documento</div>
              <div class="th">Fecha de vigencia</div>
              <div class="th"></div>
            </div>
          </div>
          <div class="tbody">
            <div *ngFor="let item of detailData.documents; let i = index" class="tr"
              [ngClass]="(!updatingDocument[i] ? false : updatingDocument[i].isEditing) ? 'tr--load' : ''">
              <div class="td td--name">
                <p>{{item.description}}<app-tooltip [text]="getTextOfEntity(item?.tooltip) || ''"></app-tooltip>
                </p>
                <h6 class="txt txt--paragraph">{{getTextOfEntity(item?.hint)}}</h6>
              </div>
              <div class="td td--doc td--hide">
                <app-download-document [driverMdmId]="this.detailData.driverMdmid" [requirementId]="this.detailData.id"
                  [assetId]="this.detailData.assetId" [documentId]="item.id" [documentName]="item.description">
                </app-download-document>
              </div>
              <div class="td td--date td--hide">
                <p *ngIf="item.dateEmit">Emisión el {{item.dateEmit | date: 'dd/MM/yyyy'}}</p>
                <p *ngIf="!item.dateEmit && item.dateFrom && item.dateUntil">Del {{item.dateFrom | date: 'dd/MM/yyyy'}}
                  al {{item.dateUntil | date: 'dd/MM/yyyy'}}
                </p>
                <p *ngIf="!item.dateEmit && item.dateFrom && !item.dateUntil">Del {{item.dateFrom | date: 'dd/MM/yyyy'}}
                  a Indefinido
                </p>
              </div>
              <div class="td td--hide">
                <a (click)="showDocumentUpdateForm(i, item.id, item.documentRequiredTypeId)"
                  class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0 js-load">
                  <img src="assets/img/lapiz.png" alt="">Actualizar documentos</a>
              </div>
              <div class="td td--load td--calendar" style="vertical-align: baseline !important;">
                <div class="form">
                  <app-attach-document *ngIf="detailData.assetId && detailData.driverMdmid"
                    (stateEmitter)="onFileSelected(i, $event)" [requiredDocumentId]="item.documentRequiredTypeId"
                    [requirementId]="id" [assetId]="detailData.assetId" [driverMdmid]="detailData.driverMdmid">
                  </app-attach-document>
                  <div class="form__error u-mt10 position-absolute"
                    *ngIf="(updatingDocument[i]?.errorKey == 'fileUrl' && updatingDocument[i]?.errorText)">
                    {{updatingDocument[i]?.errorText}}
                  </div>
                </div>
              </div>
              <ng-template [ngIf]="item.dateEmit">
                <div class="td td--load td--calendar">
                  <div class="form">
                    <label for="" class="label">
                      Emisión
                    </label>
                    <app-calendar [defaultDate]="item.dateEmit"
                      (valueEmitter)="onCalendarSetDate(i, 'dateEmit', $event)">
                    </app-calendar>
                    <div class="form__error u-mt10 position-absolute"
                      *ngIf="(updatingDocument[i]?.errorKey == 'dateEmit' && updatingDocument[i]?.errorText)">
                      {{updatingDocument[i]?.errorText}}
                    </div>
                    <h6 class="form__info global-unmount">
                      *Formato PDF. Max. 10 MB
                    </h6>
                  </div>
                </div>
                <div class="td td--load td--calendar container-calendarPad">
                </div>

              </ng-template>
              <ng-template [ngIf]="!item.dateEmit && item.dateFrom">
                <div class="td td--load td--calendar container-calendarPad">
                  <div class="form margin-10">
                    <label for="" class="label">
                      Desde
                    </label>
                    <app-calendar [defaultDate]="item.dateFrom"
                      (valueEmitter)="onCalendarSetDate(i, 'dateFrom', $event)">
                    </app-calendar>
                    <div class="form__error u-mt10 position-absolute"
                      *ngIf="(updatingDocument[i]?.errorKey == 'dateFrom' && updatingDocument[i]?.errorText)">
                      {{updatingDocument[i]?.errorText}}
                    </div>
                    <h6 class="form__info global-unmount">
                      *Formato PDF. Max. 10 MB
                    </h6>
                  </div>
                </div>
                <div class="td td--load td--calendar container-calendarPad ">
                  <div class="form margin-10">
                    <label for="" class="label">
                      Hasta
                    </label>
                    <app-calendar class="app-calendar" [defaultDate]="item.dateUntil" [canBeUndefined]="true"
                      (valueEmitter)="onCalendarSetDate(i, 'dateUntil', $event)"></app-calendar>
                    <div class="form__error u-mt10 position-absolute"
                      *ngIf="(updatingDocument[i]?.errorKey == 'dateUntil' && updatingDocument[i]?.errorText)">
                      {{updatingDocument[i]?.errorText}}
                    </div>
                    <h6 class="form__info global-unmount">
                      *Formato PDF. Max. 10 MB
                    </h6>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="request__send u-bt u-bt--grey u-pt20">
          <div class="form">
            <div class="form__check">
              <input type="checkbox" name="checkbox" value="agree-terms" id="agreeTerms" [formControl]="agreeTerms">
              <label for="agreeTerms">
                <div class="fakebox fakebox--grey"></div>
                <span>&nbsp;</span>
              </label>
              <span class="spanTerm-aconditions ">
                Confirmo que he leído los <a (click)="showModalConfirmTermsAndConditions()"
                  class="no-padding hover-hand" data-modal="modal01">términos y condiciones</a> y doy fe de la veracidad
                de
                los documentos ingresados para evitar sanciones asociadas.
              </span>
            </div>
          </div>
          <div class="buttons u-mt20">
            <div class="row">
              <div class="col-md-2 order-md-1 order-2">
                <a class="btn btn--link" routerLink="/tasks/task-list">Volver</a>
              </div>
              <div class="col-md-10 order-md-2 order-1">

                <button type="button" class="btn btn--primary modal__trigger"
                  [attr.disabled]="agreeTerms.value && formOk ? null : true" data-modal="modal02"
                  (click)="showModalConfirmUpdateDocuments()">Actualizar documentos</button>
              </div>

            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
